(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('RacerDeleteController',RacerDeleteController);

    RacerDeleteController.$inject = ['$uibModalInstance', 'entity', 'Racer'];

    function RacerDeleteController($uibModalInstance, entity, Racer) {
        var vm = this;

        vm.racer = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Racer.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
